import React from "react";

/** First visible Running Total variable cell in row/column scan order; null if none. */
export type RunningTotalFirstVariableCellCoords = { rowIndex: number; colIndex: number };

/**
 * Set once per Running Total table in GridRenderer (StandardGrid). Undefined outside that subtree.
 */
export const RunningTotalFirstVariableCellContext = React.createContext<
    RunningTotalFirstVariableCellCoords | null | undefined
>(undefined);

export function useRunningTotalFirstVariableCellCoords():
    | RunningTotalFirstVariableCellCoords
    | null
    | undefined {
    return React.useContext(RunningTotalFirstVariableCellContext);
}
